import {
  fixedNumber,
  formatDateTimeZone,
  getSettings,
} from "@/utils/utils";

export default {
  data(): any {
    return {};
  },

  methods: {
    getHoursAndMinutes(date) {
      const d = formatDateTimeZone(date);
      return `${d.hour}:${d.minutes}`;
    },

    getFullDateTime(date) {
      const d = formatDateTimeZone(date);
      return `${d.day}-${d.month}-${d.year} ${d.hour}:${d.minutes}`;
    },

    getFullDate(date) {
      const d = formatDateTimeZone(date);
      return `${d.day}-${d.month}-${d.year}`;
    },

    getFullDateYMD(date) {
      const d = formatDateTimeZone(date);
      return `${d.year}-${d.month}-${d.day}`;
    },

    generateOrdinalNumber(number) {
      if (number < 1 || !Number.isInteger(number)) {
        return "Invalid input";
      }

      const lastDigit = number % 10;
      const suffix =
        number % 100 > 10 && number % 100 < 14
          ? "th"
          : lastDigit === 1
          ? "st"
          : lastDigit === 2
          ? "nd"
          : lastDigit === 3
          ? "rd"
          : "th";

      return `${number}${suffix}`;
    },

    fixedNumber(number) {
      return fixedNumber(number);
    },

    genFlagCountryImage(countryCode) {
      let flag = countryCode.toLowerCase();
      if (flag == "uk") {
        flag = "gb";
      }
      return `https://flagcdn.com/48x36/${flag}.png`;
    },

    validateInput(event, allowDecimal = false) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      if (allowedKeys.includes(event.key)) return;
      if (event.ctrlKey || event.metaKey) return;

      const input = event.target as HTMLInputElement;
      const isDigit = /^\d$/.test(event.key);

      if (isDigit) {
        if (!allowDecimal) return;
        const val = input.value;
        const start = input.selectionStart ?? val.length;
        const end = input.selectionEnd ?? val.length;
        const dotIdx = val.indexOf(".");
        if (dotIdx !== -1 && start > dotIdx && start === end) {
          const decimalLen = val.length - dotIdx - 1;
          if (decimalLen >= 2) event.preventDefault();
        }
        return;
      }

      const isDecimalKey =
        event.key === "." ||
        event.code === "Period" ||
        event.code === "NumpadDecimal";

      if (allowDecimal && isDecimalKey) {
        const val = input.value;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        const selected = val.slice(start, end);
        const withoutSelection = val.slice(0, start) + val.slice(end);
        if (withoutSelection.includes(".") && !selected.includes(".")) {
          event.preventDefault();
        }
        return;
      }

      if (!allowDecimal) {
        const char = String.fromCharCode(event.keyCode);
        if (/^\d$/.test(char)) return;
        if (event.key.includes("Arrow")) return;
        if (event.key === "Backspace") return;
      }

      event.preventDefault();
    },

    validateStakeInput(event) {
      this.validateInput(event, true);
    },

    generateString(places) {
      return Array.from({ length: places }, (_, index) => index + 1).join(",");
    },

    settingParams() {
      return getSettings();
    },
  },
};
